<template>
  <!-- Оверлей -->
  <Teleport to="body">
    <Transition name="fade">
      <div
        v-if="authStore.isAuthOpen"
        class="fixed inset-0 z-[100] flex items-end justify-center"
      >
        <!-- Затемнение -->
        <div class="absolute inset-0 bg-black/40 backdrop-blur-[2px]" @click="authStore.closeAuthPopup()" />

        <!-- Модалка -->
        <Transition name="slide-up">
          <div
            v-if="authStore.isAuthOpen"
            ref="modalRef"
            class="relative w-full max-w-[430px] bg-cream rounded-t-3xl px-6 pt-5 pb-sheet-8 shadow-2xl"
            :style="{ minHeight: '85vh', maxHeight: '90vh', overflowY: swipeY > 0 ? 'hidden' : 'auto', transform: swipeY > 0 ? `translateY(${swipeY}px)` : '', transition: swipeTransition }"
            @click.stop
            @touchstart.passive="onSwipeStart"
            @touchmove.passive="onSwipeMove"
            @touchend="onSwipeEnd"
          >
            <!-- Хэндл -->
            <div class="w-10 h-1 bg-sand rounded-full mx-auto mb-5" />

            <!-- Логотип -->
            <img
              src="https://bceae427-af4b-44d1-9b11-1561dfcf1d1c.selstorage.ru/Zoya/Zoya_logo_transparent.png"
              alt="Зоя"
              class="w-16 h-16 mx-auto mt-8 mb-10"
            />

            <!-- Чекбоксы -->
            <div class="flex flex-col gap-3 mb-6">
              <label class="flex items-start gap-3.5 cursor-pointer">
                <input type="checkbox" v-model="agreedTerms" class="accent-[#41291A] mt-0.5 w-5 h-5 shrink-0" />
                <span class="text-13 text-ink leading-snug">
                  Я принимаю условия
                  <a href="/legal/terms" target="_blank" class="underline text-ai">Пользовательского соглашения</a>.
                </span>
              </label>
              <label class="flex items-start gap-3.5 cursor-pointer">
                <input type="checkbox" v-model="agreedPrivacy" class="accent-[#41291A] mt-0.5 w-5 h-5 shrink-0" />
                <span class="text-13 text-ink leading-snug">
                  Я даю
                  <a href="/legal/consent" target="_blank" class="underline text-ai">Согласие на обработку персональных данных</a>
                  и подтверждаю ознакомление с
                  <a href="/legal/privacy" target="_blank" class="underline text-ai">Политикой конфиденциальности</a>.
                </span>
              </label>
            </div>

            <!-- OTP: Шаг 1 — Email -->
            <div v-if="otpStep === 'email'" class="mb-6">
              <p class="text-16 font-semibold text-ink text-center mb-4 leading-snug">
                Введите email для входа
              </p>
              <input
                v-model="otpEmailInput"
                type="email"
                inputmode="email"
                autocomplete="email"
                placeholder="your@email.com"
                class="otp-input mb-3"
                @input="domainTypo = null"
                @keyup.enter="handleSendOtp"
              />
              <!-- Опечатка в домене: треть стоп-листа Unisender — gamil.com,
                   yabdex.ru, mail.run. Письмо туда отбивается, а человек видит
                   «код не приходит». Спрашиваем до отправки. -->
              <div v-if="domainTypo" class="text-13 text-ink text-center mb-3">
                Возможно, опечатка. Вы имели в виду <b>{{ domainTypo.fixed }}</b>?
                <div class="flex justify-center gap-4 mt-2">
                  <button @click="acceptTypoFix" class="text-ai underline">Да, исправить</button>
                  <button @click="sendAsTyped" class="text-ai underline">Нет, отправить как есть</button>
                </div>
              </div>
              <button
                @click="handleSendOtp"
                :disabled="!bothAgreed || !otpEmailInput || authStore.loading"
                class="otp-submit-btn"
              >
                <template v-if="authStore.loading">
                  <div class="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                </template>
                <template v-else>Продолжить</template>
              </button>
            </div>

            <!-- OTP: Шаг 2 — Код -->
            <div v-if="otpStep === 'code'" class="mb-6">
              <p class="text-15 font-semibold text-ink text-center mb-1">
                Введите код
              </p>
              <p class="text-13 text-warm text-center mb-2">
                Отправили на {{ otpEmailInput }}
              </p>
              <div class="flex items-center justify-center gap-1.5 text-13 text-ink bg-tip rounded-[10px] px-3 py-2 mb-4 leading-snug">
                <span class="text-16 shrink-0">📬</span>
                {{ ty ? 'Проверь' : 'Проверьте' }} папки «Спам» и «Рассылки»
              </div>
              <input
                ref="codeInputRef"
                v-model="otpCodeInput"
                type="text"
                inputmode="numeric"
                pattern="[0-9]*"
                maxlength="6"
                placeholder="000000"
                class="otp-code-input mb-3"
                autocomplete="one-time-code"
                @keyup.enter="handleVerifyOtp"
              />
              <button
                @click="handleVerifyOtp"
                :disabled="!otpCodeInput || otpCodeInput.length !== 6 || authStore.loading"
                class="otp-submit-btn mb-3"
              >
                <template v-if="authStore.loading">
                  <div class="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                </template>
                <template v-else>Войти</template>
              </button>
              <p class="text-13 text-center text-warm">
                <template v-if="resendTimer > 0">
                  Отправить повторно через {{ resendTimer }} сек
                </template>
                <template v-else-if="resendCount < 3">
                  <button @click="handleResendOtp" class="text-ai underline">Отправить код повторно</button>
                </template>
                <template v-else>
                  Превышено количество отправок
                </template>
              </p>
            </div>

            <!-- Ошибка -->
            <p v-if="authStore.error" class="text-13 text-red-500 text-center mb-4">
              {{ authStore.error }}
            </p>

            <!-- Разделитель -->
            <div class="flex items-center gap-3 mb-4">
              <div class="flex-1 h-px bg-sand" />
              <span class="text-13 text-warm">или</span>
              <div class="flex-1 h-px bg-sand" />
            </div>

            <!-- OAuth кнопки -->
            <div class="flex flex-col gap-3">
              <!--
                Sign in with Apple (только нативный iOS) — первой: гайдлайн
                App Store 4.8 и HIG требуют, чтобы кнопка Apple была не менее
                заметной, чем другие способы входа. Логотип — официальный знак
                Apple в чёрном цвете и того же размера, что у Яндекса и Google;
                перекрашивать и уменьшать его HIG запрещает.
              -->
              <button
                v-if="showAppleSignIn"
                @click="loginApple"
                :disabled="!bothAgreed || authStore.loading"
                class="oauth-btn"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="#000" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"/>
                </svg>
                Войти через Apple
              </button>

              <button
                @click="loginYandex"
                :disabled="!bothAgreed || authStore.loading"
                class="oauth-btn"
              >
                <!-- Yandex SVG -->
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M2.04 12c0-5.523 4.476-10 10-10 5.522 0 10 4.477 10 10s-4.478 10-10 10c-5.524 0-10-4.477-10-10z" fill="#FC3F1D"/>
                  <path d="M13.32 7.666h-.924c-1.694 0-2.585.858-2.585 2.123 0 1.43.616 2.1 1.881 2.959l1.045.704-3.003 4.487H7.49l2.695-4.014c-1.55-1.111-2.42-2.19-2.42-4.015 0-2.288 1.595-3.85 4.62-3.85h3.003v11.868H13.32V7.666z" fill="#fff"/>
                </svg>
                Войти через Яндекс
              </button>

              <button
                v-if="showAppleSignIn"
                @click="loginGoogle"
                :disabled="!bothAgreed || authStore.loading"
                class="oauth-btn"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48">
                  <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                  <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                  <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                  <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                </svg>
                Войти через Google
              </button>

              <button
                v-if="!showAppleSignIn"
                @click="loginVk"
                :disabled="!bothAgreed || authStore.loading || vkLoading"
                class="oauth-btn"
              >
                <template v-if="vkLoading">
                  <div class="w-5 h-5 border-2 border-sand border-t-[#0077FF] rounded-full animate-spin" />
                  Загрузка...
                </template>
                <template v-else>
                  <!-- Официальный знак VK ID (id.vk.com), а не нарисованный от руки -->
                  <img src="/vk-logo.png" alt="" width="20" height="20" class="rounded-[4px]" />
                  Войти через VK
                </template>
              </button>

              <!--
                Вход через Telegram отключён 15.08.2026, заменён на VK ID.
                Виджет грузится с telegram.org, а он у части пользователей не
                открывается — кнопка вела в тупик с ошибкой «возможно,
                заблокирован провайдером». С сервера домен тоже недоступен
                (10 из 10 запросов к api.telegram.org — таймаут), из-за чего
                лежит и бот. Код входа (loginTelegram, /api/auth/telegram)
                оставлен: если доступ вернётся или появится прокси, достаточно
                снять комментарий.
              -->
              <button
                v-if="false"
                @click="loginTelegram"
                :disabled="!bothAgreed || authStore.loading || tgLoading"
                class="oauth-btn"
              >
                <template v-if="tgLoading">
                  <div class="w-5 h-5 border-2 border-sand border-t-[#2AABEE] rounded-full animate-spin" />
                  Загрузка...
                </template>
                <template v-else>
                  <!-- Telegram SVG -->
                  <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_4393_523)">
                      <path d="M17.7447 2.64924C15.2839 3.7611 4.7323 8.52902 1.8169 9.82851C-0.138303 10.6609 1.0063 11.4413 1.0063 11.4413C1.0063 11.4413 2.6753 12.0655 4.1061 12.5338C5.5367 13.002 6.2997 12.4818 6.2997 12.4818L13.0237 7.53957C15.4081 5.77077 14.8359 7.22735 14.2635 7.85179C13.0237 9.20451 10.9731 11.3372 9.2563 13.0541C8.4933 13.7824 8.8747 14.4066 9.2087 14.7188C10.4485 15.8634 13.8345 18.2045 14.0251 18.3605C15.0325 19.1385 17.0141 20.2585 17.3155 17.8923L18.5077 9.72466C18.8893 6.9675 19.2707 4.41826 19.3183 3.68997C19.4615 1.92095 17.7447 2.64924 17.7447 2.64924Z" fill="#1B92D1"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_4393_523">
                        <rect width="20" height="21.8182" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                  Войти через Telegram
                </template>
              </button>
            </div>

            <!--
              Для тех, кто заводил аккаунт через Telegram. Кнопка входа убрана
              (виджет telegram.org у многих не грузится), и без привязанной
              почты такой человек остаётся без единого способа войти — таких
              аккаунтов больше двухсот. Mini App при этом работает: подпись
              initData проверяется у нас локально, недоступность Telegram API
              с сервера ему не мешает. Внутри приложение само предложит
              привязать email.
            -->
            <div v-if="!authStore.isTelegramApp" class="mt-5 rounded-2xl bg-[#F0EBE2] px-4 py-3.5">
              <p class="text-13 text-ink leading-snug mb-1">
                Раньше входили через Telegram?
              </p>
              <p class="text-13 text-ink leading-snug">
                <a href="https://t.me/zoya_zozhnik_bot" target="_blank" rel="noopener"
                   class="underline text-ai">Откройте Зою в Telegram</a>
                — вы попадёте в свой аккаунт и сможете привязать почту, чтобы
                входить и с других устройств.
              </p>
            </div>

            <!-- Dev-login для staging -->
            <div v-if="isStaging" class="mt-5 p-4 bg-white rounded-2xl">
              <p class="text-13 font-semibold text-ink mb-3 text-center">Staging: вход по email+пароль</p>
              <input v-model="devEmail" type="email" placeholder="Email" class="dev-input mb-2" />
              <input v-model="devPassword" type="password" placeholder="Пароль (мин. 8 символов)" class="dev-input mb-2" />
              <input v-model="devName" type="text" placeholder="Имя (для регистрации)" class="dev-input mb-3" />
              <div class="flex gap-2">
                <button @click="devLogin" :disabled="authStore.loading" class="dev-btn flex-1">Войти</button>
                <button @click="devRegister" :disabled="authStore.loading" class="dev-btn flex-1 !bg-ink !text-white">Регистрация</button>
              </div>
            </div>
          </div>
        </Transition>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue'
import { Capacitor } from '@capacitor/core'
import { Browser } from '@capacitor/browser'
import { useAuthStore } from '../store/auth.js'
import api from '../services/api.js'
import { track } from '../analytics.js'
import { authorizeApple } from '../services/apple.js'

const authStore = useAuthStore()
const ty = computed(() => authStore.user?.address_form !== 'вы')

// ---- Swipe-to-close ----
const modalRef = ref(null)
const swipeY = ref(0)
const swipeTransition = ref('')
let touchStartY = 0
let touchStartScrollTop = 0
let swiping = false

function onSwipeStart(e) {
  swipeTransition.value = ''
  const touch = e.touches[0]
  touchStartY = touch.clientY
  touchStartScrollTop = modalRef.value?.scrollTop || 0
  swiping = false
}

function onSwipeMove(e) {
  const touch = e.touches[0]
  const dy = touch.clientY - touchStartY
  // Only start swiping down if content is scrolled to top
  if (dy > 0 && touchStartScrollTop <= 0) {
    swiping = true
    swipeY.value = dy * 0.6 // dampen
  } else if (swiping && dy <= 0) {
    swipeY.value = 0
  }
}

function onSwipeEnd() {
  if (swipeY.value > 120) {
    swipeTransition.value = 'transform 0.25s ease-out'
    swipeY.value = window.innerHeight
    setTimeout(() => {
      authStore.closeAuthPopup()
      swipeY.value = 0
      swipeTransition.value = ''
    }, 250)
  } else {
    swipeTransition.value = 'transform 0.2s ease-out'
    swipeY.value = 0
    setTimeout(() => { swipeTransition.value = '' }, 200)
  }
  swiping = false
}

// ---- OTP state ----
const otpStep = ref('email') // 'email' | 'code'
const otpEmailInput = ref('')
const otpCodeInput = ref('')
const codeInputRef = ref(null)
const resendTimer = ref(0)
const resendCount = ref(0)
let timerInterval = null

function startResendTimer() {
  resendTimer.value = 60
  clearInterval(timerInterval)
  timerInterval = setInterval(() => {
    resendTimer.value--
    if (resendTimer.value <= 0) clearInterval(timerInterval)
  }, 1000)
}

// Частые опечатки в домене почты. Список — из стоп-листа Unisender за
// сентябрь 2026: письма туда не доходят по определению.
const DOMAIN_TYPOS = {
  'gamil.com': 'gmail.com', 'gnail.com': 'gmail.com', 'gmial.com': 'gmail.com', 'gmali.com': 'gmail.com',
  'gmai.com': 'gmail.com', 'gmail.con': 'gmail.com', 'gmail.co': 'gmail.com', 'gmail.ru': 'gmail.com',
  'yabdex.ru': 'yandex.ru', 'yamdex.ru': 'yandex.ru', 'yndex.ru': 'yandex.ru', 'yandex.tu': 'yandex.ru',
  'mail.run': 'mail.ru', 'maik.ru': 'mail.ru', 'mial.ru': 'mail.ru', 'mai.ru': 'mail.ru', 'mail.tu': 'mail.ru',
  'icloud.co': 'icloud.com', 'iclod.com': 'icloud.com', 'hotmail.co': 'hotmail.com', 'outlok.com': 'outlook.com',
}
const domainTypo = ref(null) // { typed, fixed }
let typoAccepted = ''        // адрес, который человек подтвердил «как есть»

function checkDomainTypo(email) {
  const domain = email.split('@')[1]?.toLowerCase()
  const fixed = domain && DOMAIN_TYPOS[domain]
  if (!fixed || typoAccepted === email) return false
  domainTypo.value = { typed: domain, fixed: email.split('@')[0] + '@' + fixed }
  return true
}
function acceptTypoFix() {
  otpEmailInput.value = domainTypo.value.fixed
  domainTypo.value = null
  handleSendOtp()
}
function sendAsTyped() {
  typoAccepted = otpEmailInput.value.trim()
  domainTypo.value = null
  handleSendOtp()
}

async function handleSendOtp() {
  if (!otpEmailInput.value) return
  const email = otpEmailInput.value.trim()
  if (checkDomainTypo(email)) return
  try {
    await authStore.sendOtp(email)
    otpStep.value = 'code'
    startResendTimer()
    resendCount.value++
    nextTick(() => codeInputRef.value?.focus())
  } catch {
    // error is set in store
  }
}

async function handleVerifyOtp() {
  if (!otpCodeInput.value || otpCodeInput.value.length !== 6) return
  try {
    if (authStore.isGuest) {
      // Guest registration: link credentials to existing guest account
      await authStore.linkGuestAccount('otp', {
        email: otpEmailInput.value.trim(),
        code: otpCodeInput.value.trim(),
      })
      authStore.closeAuthPopup()
    } else {
      await authStore.verifyOtp(otpEmailInput.value.trim(), otpCodeInput.value.trim())
    }
  } catch {
    // error is set in store
  }
}

async function handleResendOtp() {
  if (resendTimer.value > 0 || resendCount.value >= 3) return
  try {
    await authStore.sendOtp(otpEmailInput.value.trim())
    startResendTimer()
    resendCount.value++
    authStore.error = null
  } catch {
    // error is set in store
  }
}

function goBackToEmail() {
  otpStep.value = 'email'
  otpCodeInput.value = ''
  authStore.error = null
}

// Reset OTP state when modal opens/closes
watch(() => authStore.isAuthOpen, (open) => {
  if (open) {
    track('auth_modal_opened')
  } else {
    otpStep.value = 'email'
    otpEmailInput.value = ''
    otpCodeInput.value = ''
    resendTimer.value = 0
    resendCount.value = 0
    clearInterval(timerInterval)
  }
})

// ---- Checkboxes ----
const agreedTerms = ref(false)
const agreedPrivacy = ref(false)
const bothAgreed = computed(() => agreedTerms.value && agreedPrivacy.value)

// Dev-login для staging
const isStaging = window.location.hostname.includes('staging')
const devEmail = ref('')
const devPassword = ref('')
const devName = ref('')

async function devLogin() {
  if (!devEmail.value || !devPassword.value) return
  await authStore.loginWithEmail(devEmail.value, devPassword.value)
}

async function devRegister() {
  if (!devEmail.value || !devPassword.value || !devName.value) return
  await authStore.registerWithEmail(devName.value, devEmail.value, devPassword.value)
}

// ---- Apple Sign-In (iOS native only) ----
const showAppleSignIn = Capacitor.getPlatform() === 'ios'

async function loginApple() {
  authStore.error = null
  track('auth_method_selected', { method: 'apple' })
  try {
    const r = await authorizeApple()
    if (authStore.isGuest) {
      await authStore.linkGuestAccount('apple', {
        identityToken: r.identityToken,
        authorizationCode: r.authorizationCode,
        user: { email: r.email, givenName: r.givenName, familyName: r.familyName },
      })
      authStore.closeAuthPopup()
    } else {
      await authStore.loginWithApple(r)
    }
  } catch (e) {
    if (e.message?.includes('canceled') || e.code === '1001') return // user cancelled
    authStore.error = 'Ошибка входа через Apple'
    console.error('Apple Sign-In error:', e)
  }
}

// ---- Google Sign-In ----
function loadGoogleScript() {
  return new Promise((resolve) => {
    if (window.google?.accounts?.oauth2) return resolve()
    const s = document.createElement('script')
    s.src = 'https://accounts.google.com/gsi/client'
    const timeout = setTimeout(() => resolve(), 5000)
    s.onload = () => { clearTimeout(timeout); resolve() }
    s.onerror = () => { clearTimeout(timeout); resolve() }
    document.head.appendChild(s)
  })
}

async function loginGoogle() {
  authStore.error = null
  track('auth_method_selected', { method: 'google' })

  // Capacitor native: open external browser → server-side OAuth flow
  if (Capacitor.isNativePlatform()) {
    const url = `https://zoya.zozhnik.ru/api/auth/google/mobile`
    try {
      await Browser.open({ url })
    } catch (e) {
      console.error('Browser.open failed:', e)
      window.open(url, '_blank')
    }
    return
  }

  // Web: popup flow with Google Identity Services
  try {
    const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID
    if (!clientId) {
      authStore.error = 'Google Client ID не настроен'
      return
    }

    await loadGoogleScript()
    if (!window.google?.accounts?.oauth2) {
      authStore.error = 'Не удалось загрузить Google (возможно, заблокирован провайдером)'
      return
    }

    const client = window.google.accounts.oauth2.initCodeClient({
      client_id: clientId,
      scope: 'openid email profile',
      ux_mode: 'popup',
      callback: async (response) => {
        if (response.error) {
          authStore.error = 'Ошибка входа через Google'
          return
        }
        if (authStore.isGuest) {
          try {
            await authStore.linkGuestAccount('google', { code: response.code })
            authStore.closeAuthPopup()
          } catch (err) {
            authStore.error = err.response?.data?.error || 'Ошибка привязки Google'
          }
        } else {
          await authStore.loginWithGoogle(response.code)
        }
      },
    })
    client.requestCode()
  } catch (e) {
    authStore.error = 'Ошибка инициализации Google Sign-In'
    console.error('Google Sign-In error:', e)
  }
}

// ---- Telegram Login Widget (programmatic via Telegram.Login.auth) ----
function loadTelegramWidget() {
  return new Promise((resolve) => {
    if (window.Telegram?.Login?.auth) return resolve()
    const s = document.createElement('script')
    s.src = 'https://telegram.org/js/telegram-widget.js?22'
    const timeout = setTimeout(() => resolve(), 5000)
    s.onload = () => { clearTimeout(timeout); resolve() }
    s.onerror = () => { clearTimeout(timeout); resolve() }
    document.head.appendChild(s)
  })
}

const tgLoading = ref(false)
const vkLoading = ref(false)

async function loginTelegram() {
  track('auth_method_selected', { method: 'telegram' })
  const botId = import.meta.env.VITE_TELEGRAM_BOT_ID
  if (!botId) {
    authStore.error = 'Telegram бот не настроен'
    return
  }
  tgLoading.value = true
  await loadTelegramWidget()
  tgLoading.value = false
  if (!window.Telegram?.Login?.auth) {
    authStore.error = 'Не удалось загрузить Telegram (возможно, заблокирован провайдером)'
    return
  }
  window.Telegram.Login.auth({ bot_id: botId, request_access: 'write' }, async (data) => {
    if (!data) return // пользователь отменил
    if (authStore.isGuest) {
      try {
        await authStore.linkGuestAccount('telegram', { loginWidget: data })
        authStore.closeAuthPopup()
      } catch {
        // error is set in store
      }
    } else {
      await authStore.loginWithTelegram(data)
    }
  })
}

// ---- Yandex (popup + postMessage on web, external browser on native) ----
// ── VK ID ────────────────────────────────────────────────────────────────
// VK ID работает по OAuth 2.1 с обязательным PKCE: генерируем code_verifier,
// отдаём VK только его хеш, а сам verifier держим в sessionStorage до возврата.
// Так перехваченный код бесполезен без нашего браузера.
function b64url(bytes) {
  return btoa(String.fromCharCode(...new Uint8Array(bytes)))
    .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

async function buildPkce() {
  const verifier = b64url(crypto.getRandomValues(new Uint8Array(48)))
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))
  return { verifier, challenge: b64url(digest) }
}

async function loginVk() {
  authStore.error = null
  track('auth_method_selected', { method: 'vk' })

  // Нативные сборки (APK/IPA): открываем системный браузер, обмен кода делает
  // сервер, возврат — по deep link zoya://auth. В WebView флоу не замкнуть.
  if (Capacitor.isNativePlatform()) {
    const url = `https://zoya.zozhnik.ru/api/auth/vk/mobile`
    try {
      await Browser.open({ url })
    } catch (e) {
      console.error('Browser.open failed:', e)
      window.open(url, '_blank')
    }
    return
  }

  const clientId = import.meta.env.VITE_VK_CLIENT_ID
  if (!clientId) {
    authStore.error = 'VK ID не настроен'
    return
  }

  vkLoading.value = true
  const { verifier, challenge } = await buildPkce()
  const state = b64url(crypto.getRandomValues(new Uint8Array(16)))
  sessionStorage.setItem('vk-code-verifier', verifier)
  sessionStorage.setItem('vk-state', state)

  const redirectUri = `${window.location.origin}/auth/vk/callback`
  const url =
    `https://id.vk.com/authorize?response_type=code` +
    `&client_id=${clientId}` +
    `&redirect_uri=${encodeURIComponent(redirectUri)}` +
    `&code_challenge=${challenge}&code_challenge_method=S256` +
    `&state=${state}&scope=email`

  // Как и у Яндекса: в PWA и на мобильных popup теряет window.opener после
  // кросс-доменного редиректа, поэтому там навигируем текущую вкладку.
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  const isPWA = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone
  if (isMobile || isPWA) {
    window.location.href = url
    return
  }

  const popup = window.open(url, 'vk-auth', 'width=600,height=700,left=300,top=100')
  vkLoading.value = false

  const handleMessage = async (e) => {
    if (e.origin !== window.location.origin) return
    if (e.data?.type === 'vk-code' && e.data.credentials) {
      window.removeEventListener('message', handleMessage)
      popup?.close()
      try {
        await authStore.linkGuestAccount('vk', e.data.credentials)
        authStore.closeAuthPopup()
      } catch (err) {
        authStore.error = err.response?.data?.error || 'Ошибка привязки VK'
      }
    } else if (e.data?.type === 'vk-auth-done') {
      window.removeEventListener('message', handleMessage)
      popup?.close()
      authStore.restoreSession()
      authStore.closeAuthPopup()
    } else if (e.data?.type === 'vk-error') {
      window.removeEventListener('message', handleMessage)
      popup?.close()
      vkLoading.value = false
    }
  }
  window.addEventListener('message', handleMessage)
}

async function loginYandex() {
  authStore.error = null
  track('auth_method_selected', { method: 'yandex' })

  // Capacitor native: open external browser → server-side OAuth flow
  if (Capacitor.isNativePlatform()) {
    const url = `https://zoya.zozhnik.ru/api/auth/yandex/mobile`
    try {
      await Browser.open({ url })
    } catch (e) {
      console.error('Browser.open failed:', e)
      // Fallback: system browser
      window.open(url, '_blank')
    }
    return
  }

  // Web/PWA: OAuth flow
  const redirectUri = `${window.location.origin}/auth/yandex/callback`
  const url =
    `https://oauth.yandex.ru/authorize?response_type=code` +
    `&client_id=${import.meta.env.VITE_YANDEX_CLIENT_ID}` +
    `&redirect_uri=${encodeURIComponent(redirectUri)}`

  // На мобильных и в PWA popup не работает надёжно:
  // window.open → новая вкладка, window.opener теряется после кросс-доменного редиректа.
  // Навигируем текущую страницу напрямую — всё происходит в одном контексте.
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  const isPWA = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone
  if (isMobile || isPWA) {
    window.location.href = url
    return
  }

  // Desktop: popup flow
  const popup = window.open(url, 'yandex-auth', 'width=600,height=700,left=300,top=100')

  const handleMessage = async (e) => {
    if (e.data?.type === 'yandex-code' && e.data.code) {
      // Guest flow: YandexCallback sent the code for guest linking
      window.removeEventListener('message', handleMessage)
      popup?.close()
      try {
        await authStore.linkGuestAccount('yandex', { code: e.data.code, redirect_uri: redirectUri })
        authStore.closeAuthPopup()
      } catch (err) {
        authStore.error = err.response?.data?.error || 'Ошибка привязки Яндекс'
      }
    } else if (e.data?.type === 'yandex-auth-done') {
      window.removeEventListener('message', handleMessage)
      popup?.close()
      // Токен уже сохранён в localStorage callback-страницей — подхватываем
      authStore.restoreSession()
      authStore.closeAuthPopup()
    } else if (e.data?.type === 'yandex-error') {
      window.removeEventListener('message', handleMessage)
      popup?.close()
    }
  }
  window.addEventListener('message', handleMessage)
}
</script>

<style scoped>
.otp-input {
  width: 100%;
  height: 48px;
  border-radius: 16px;
  border: 1px solid #D9D0C4;
  padding: 0 16px;
  font-size: var(--fs-16);
  color: var(--ink);
  background: white;
  outline: none;
  -webkit-appearance: none;
}
.otp-input:focus {
  border-color: var(--ai);
  box-shadow: 0 0 0 3px rgba(139, 105, 20, 0.1);
}
.otp-code-input {
  width: 100%;
  height: 56px;
  border-radius: 16px;
  border: 1px solid #D9D0C4;
  padding: 0 16px;
  font-size: var(--fs-28);
  font-weight: 700;
  letter-spacing: 8px;
  text-align: center;
  color: var(--ink);
  background: white;
  outline: none;
  -webkit-appearance: none;
}
.otp-code-input:focus {
  border-color: var(--ai);
  box-shadow: 0 0 0 3px rgba(139, 105, 20, 0.1);
}
.otp-submit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  border-radius: 16px;
  background: #41291A;
  border: none;
  font-size: var(--fs-15);
  font-weight: 600;
  color: white;
  cursor: pointer;
  transition: opacity 0.15s;
}
.otp-submit-btn:disabled {
  opacity: 0.5;
}
.otp-submit-btn:active:not(:disabled) {
  transform: scale(0.98);
}
.oauth-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 48px;
  border-radius: 16px;
  background: white;
  border: none;
  font-size: var(--fs-15);
  font-weight: 600;
  color: var(--ink);
  cursor: pointer;
  transition: opacity 0.15s;
}
.oauth-btn:disabled {
  opacity: 0.5;
}
.oauth-btn:active {
  transform: scale(0.98);
}
.dev-input {
  width: 100%;
  height: 40px;
  border-radius: 10px;
  border: 1px solid #D9D0C4;
  padding: 0 12px;
  font-size: var(--fs-14);
  color: var(--ink);
  background: #FAF3E8;
  outline: none;
}
.dev-input:focus {
  border-color: var(--ai);
}
.dev-btn {
  height: 40px;
  border-radius: 10px;
  background: white;
  border: 1px solid #D9D0C4;
  font-size: var(--fs-14);
  font-weight: 600;
  color: var(--ink);
  cursor: pointer;
}
.dev-btn:disabled {
  opacity: 0.5;
}

/* Анимации */
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

.slide-up-enter-active, .slide-up-leave-active { transition: transform 0.3s cubic-bezier(0.32, 0.72, 0, 1); }
.slide-up-enter-from, .slide-up-leave-to { transform: translateY(100%); }
</style>
